import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { KAY_BURTON_BAYSIDE_META } from "./meta.ts";
import { parseKayBurtonDetailHtml } from "./parser.ts";
import { buildPaginatedUrl, buildSearchUrl } from "./runtime.ts";

export * from "./meta.ts";
export * from "./parser.ts";
export * from "./runtime.ts";

export const KAY_BURTON_BAYSIDE_ADAPTER = defineSoldOnlyAdapter(
  KAY_BURTON_BAYSIDE_META,
  buildSearchUrl,
  {
    parseDetailHtml: parseKayBurtonDetailHtml,
    // Direct fetch served its search and detail pages in full (probe, 2026-10-14).
    directFirst: true,
    buildPaginatedUrl,
  },
);
